import { DatePipe } from '@angular/common';
import { Component, Input, EventEmitter, Output, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { DataService, ServicecallService } from 'src/app';
import { AppliedFilter, FilterField, FilterFields } from 'src/app/model/shared/components/filter-panel';

@Component({
  selector: 'app-filter-panel',
  templateUrl: './filter-panel.component.html',
  styleUrls: ['./filter-panel.component.scss']
})
export class FilterPanelComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isCollapsed: boolean;
  @Input() appliedFilter: AppliedFilter | { filterFields: AppliedFilter };
  @Input() entityFilters : any;
  @Input() pageType: string;
  @Input() searchInput: string;
  @Input() includeAlerts : {include: boolean, fieldName: string};
  @Input() includeDtc : {include: boolean, fieldName: string};
  @Input() singleSelectionFilters : string[] = [];
  @Output() collapse = new EventEmitter<any>();
  @Output() selectedFilters = new EventEmitter<any>();
  @Output() dtcAlertsFilters = new EventEmitter<any>();
  @Output() searchItem = new EventEmitter<any>();
  @Output() clearFilters = new EventEmitter<any>();

  filterForm: FormGroup;
  filterKeyValue: [string, FilterField][] | null = null;
  public _tenantGenericConfig: any;
  alertsList: { alert: string; count: number; }[];
  private _subscription: Subscription;
  isActiveAlerts = new FormControl(false);
  isActiveDTCCases = new FormControl(false);

  constructor(private _fb: FormBuilder, public service: ServicecallService, private _datePipe: DatePipe, private _dataSer: DataService,) {
    this._subscription = _dataSer.events.subscribe((res: any) => {
      if (res.name === 'siteChanged' || res.name === 'apiRefresh' || res.name === 'entitiesListingdateApplied') {
        this.getAlertsList();
      } 
    });
  }

  ngOnChanges(): void {
    if (this.appliedFilter) {
      const filterFields = this.appliedFilter?.filterFields ?? this.appliedFilter;

      // Iterate over all keys in the appliedFilter object
      Object.keys(filterFields)?.forEach((filterKey) => {
        const appliedFilterValues = filterFields[filterKey]; // Get the values for the current key
        const formControlValue = this.filterForm?.get(filterKey)?.value; // Get the form control value for the key

        if (formControlValue) {
          const selectedValues = new Set(appliedFilterValues);

          // Update each key in the form control object to true/false
          Object.keys(formControlValue).forEach((key) => {
            formControlValue[key] = selectedValues.has(key);
          });

          // Patch the updated value back to the form
          this.filterForm?.patchValue({
            [filterKey]: formControlValue,
          });
        }
      });
    } 
    this.entityFilters?.isActiveAlerts ? this.isActiveAlerts.setValue(true): this.isActiveAlerts.setValue(false);
    this.entityFilters?.isActiveDTCCases ? this.isActiveDTCCases.setValue(true) : this.isActiveDTCCases.setValue(false);
    // else {
    //   this.filterValues = this.service.getConfiguration("entityFilter")?.filterFields ?? {};
    // }
  }

  ngOnDestroy() : any {
    this._subscription?.unsubscribe();
  }
  
  get hasFilters(): boolean {
    const hasAppliedFilters = !!this.appliedFilter && Object.values(this.appliedFilter)?.some((value) => Array.isArray(value) && value.length > 0);
    const hasOperationalStatusFilter = this.entityFilters?.operationalStatusFilter?.length > 0;
    const hasAlertsFilter = this.entityFilters?.alertsFilter?.length > 0;
    const hasActiveAlerts = this.entityFilters?.isActiveAlerts;
    const hasActiveDTCCases = this.entityFilters?.isActiveDTCCases;
  
    return hasAppliedFilters || hasOperationalStatusFilter || hasAlertsFilter || hasActiveAlerts || hasActiveDTCCases;
  }

  // Setter to update filterKeyValue with the Object.entries
  @Input()
  set filterValues(values: FilterFields) {
    this._tenantGenericConfig = this.service.getConfiguration('tenantGenericConfig') ? this.service.getConfiguration('tenantGenericConfig') : null;
    if(this.pageType && this.pageType !=='dtc' && this.pageType !== 'case'){
      this.getAlertsList();
    }
    const alerts = this.alertsList?.map(item => {return {name: item.alert, value: item.alert}});
    let filterValueWithAlerts = null;
    if(values?.['alertsFilter'] && alerts?.length) {
      filterValueWithAlerts = {
        ...values,
        alertsFilter: {
          ...values['alertsFilter'],
          fieldValues: alerts,
        },
      };
    }
    this.filterKeyValue = Object.entries(filterValueWithAlerts ?? values);

    // Creating the form dynamically based on the categories
    const formGroup: any = {};
    this.filterKeyValue.forEach(([key, value]: [string, FilterField]) => {
      formGroup[key] = this._fb.group({});
      value?.fieldValues?.forEach((item: { name: string, value: string }) => {
        formGroup[key].addControl(item.value, this._fb.control(false)); // Default unchecked
      });
    });

    // Initializing the form group with the dynamic controls
    this.filterForm = this._fb.group(formGroup);
  }

  // Getter for filterValues
  get filterValues(): FilterFields {
    return this.filterValues;
  }

  getAlertsList() : any {

    let configStartDate = null;
    let configEndDate = null;

    if (this._tenantGenericConfig?.defaultTimeRange) {
      const configHour = this._tenantGenericConfig?.defaultTimeRange || 0;

    const { startDate, endDate } = this.service.calculateDateRange(configHour);
      configEndDate = endDate;
      configStartDate = startDate;
    }
    const startDate = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 0, 0, 0, 999);
    const reqData = {
      filterList: [{type: "Status", value: "active"}],
      from: this._datePipe.transform(configStartDate ?? startDate, 'yyyy-MM-ddTHH:mm:ssZ'),
      to: this._datePipe.transform(configEndDate ?? Date.now(), 'yyyy-MM-ddTHH:mm:ssZ'),
      siteId: this.service.getSiteId(),
      filterBy: "Alert",
      status: true,
      classType: "Alert",
    };
    this.service.getAlertsCount(reqData, false, 'vehicleList').subscribe((result: any) => {
      if (result['status']) {
        if (result['response']['data']?.length) {
            this.alertsList = result['response']['data']?.[0]?.alert?.length 
              ? result['response']['data']?.[0]?.alert : [] ;
        } else {
          this.alertsList = [];
        }
      }
      else {
        this.service.toasterService({ type: 'error', msg: result?.response?.message });
        this.alertsList = [];
      }
    })
  }

  ngOnInit(): void { }

  handleClose(isClosed: boolean) {
    this.collapse.emit(isClosed);
  }

  searchOnChange(searchItem: string | null) {
    this.searchItem.emit(searchItem);
  }

  onSubmit() {
    let filtersSelected = this.filterForm.value;
    if(this.includeAlerts?.include) {
      filtersSelected.isActiveAlerts = this.isActiveAlerts?.value;
    }
    if(this.includeDtc?.include) {
      filtersSelected.isActiveDTCCases = this.isActiveDTCCases?.value;
    }
    this.selectedFilters.emit(filtersSelected);
  }

  clearAllFilters() {
    this.clearFilters.emit('clearFilter');
  }

  isSingleSelection(groupKey: string): boolean {
    return this.singleSelectionFilters?.includes(groupKey);
  }
  
  isChecked(groupKey: string, controlKey: string): boolean {
    return this.filterForm?.get([groupKey, controlKey])?.value;
  }
  
  onCheckboxChange(groupKey: string, controlKey: string, checked: boolean) {
    const group = this.filterForm?.get(groupKey) as FormGroup;
  
    if (this.isSingleSelection(groupKey)) {
      // Uncheck all others
      Object.keys(group.controls).forEach(key => {
        group.get(key)?.setValue(false);
      });
      // Set the clicked one to true
      group.get(controlKey)?.setValue(checked);
    } else {
      // Default checkbox behavior
      group.get(controlKey)?.setValue(checked);
    }
  }

}
